import React, {useState} from "react";
import Logo from "../image/logo.png"
import axios from 'axios';
import {useHistory} from "react-router-dom";

function LoginForm() {
    const uri = "https://bo.influxs.live/StraKingAPI00X/api/login";
    const [loading, setLoading] = useState(false);

    const [error, setError] = useState("");

    const [details, setDetails] = useState({username: "", password: ""});

    let history=useHistory();
    const submitHandler = e => {
        e.preventDefault();
        setError("");
        setLoading(true);
        if(details.username !=="" && details.password !== ""){
            const  dataToLogin = {
                login: details.username,
                password:details.password
            };
            axios.post(uri,dataToLogin).then(
                res=>{
                    console.log(res);
                    localStorage.setItem('token',res.data.access_token);
                    setLoading(false);
                    if(res.data.access_token !== null){
                        history.push('/listContra');
                    }
                }
            ).catch(err =>{
                setError(err.response.data.message);
                alert(err.response.data.message);
                setLoading(false);
            })
        }else {
            setLoading(false);
            setError("Renseignez votre nom d'utilisateur et votre mot de passe");
        }
    }

    /**
     * Code of view
     */
    return (
        <div className="login_form">
            <form onSubmit={submitHandler}>
                <div className="form-inner">
                    <img src={Logo} alt="Logo" className="logo"/>
                    {(error!=="") ? (<div className="error">{error}</div>) : ""}

                    {loading ? (<div className="loader">Loading ....</div>) :(<div></div>)}

                    <div className="form-group">
                        <label htmlFor="userName">Nom d'utilisateur</label>
                        <input type="text" name="userName" id="userName"
                               onChange={e => setDetails({...details, username: e.target.value})}
                               value={details.username}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input type="password" name="password" id="password"
                               onChange={e => setDetails({...details, password: e.target.value})} value={details.password}/>
                    </div>
                    <input type="submit" value="Connexion"/>
                </div>

            </form>
        </div>
    )
}

export default LoginForm;